import z from 'zod';
import { ShipmentSchema } from './Shipment';

export const ShipmentListResultSchema = z.object({
    data: z.array(ShipmentSchema),
    total: z.number(),
});

export type ShipmentListResult = z.infer<typeof ShipmentListResultSchema>;
